import { render } from "./WindChart.vue?vue&type=template&id=5095a972&scoped=true"
import script from "./WindChart.vue?vue&type=script&lang=js"
export * from "./WindChart.vue?vue&type=script&lang=js"

import "./WindChart.vue?vue&type=style&index=0&id=5095a972&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5095a972"]])

export default __exports__